import Marquee from "react-fast-marquee";
import { EXHIBITIONS } from "@/lib/assets";
import { Reveal, Overline } from "@/components/Motion";

export const ExhibitionPresence = () => (
  <section data-testid="exhibition-presence" className="py-24 md:py-32 border-y border-white/8 bg-evo-black/50">
    <div className="px-6 md:px-12 lg:px-20 mb-16">
      <Reveal><Overline className="block mb-5">Exhibition Presence</Overline></Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-evo-pearl max-w-3xl">
          Delivering at the world's leading exhibitions
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-6 text-evo-ash font-light max-w-xl leading-relaxed">
          EVO has designed and built for exhibitors at major international events across the region and beyond.
        </p>
      </Reveal>
    </div>

    <Marquee speed={32} gradient={false} autoFill pauseOnHover>
      {EXHIBITIONS.map((ex, i) => (
        <div key={i} className="mx-8 md:mx-10 flex items-center h-24" data-testid={`exhibition-${i}`}>
          {ex.logo ? (
            <div className="flex items-center justify-center h-16 md:h-20 px-7 md:px-9 bg-white border border-evo-gold/20 transition-transform duration-500 hover:scale-[1.03]">
              <img src={ex.logo} alt={ex.name} className="h-9 md:h-11 w-auto object-contain" />
            </div>
          ) : (
            <span className="font-serif italic text-3xl md:text-4xl text-evo-pearl/50 hover:text-evo-gold transition-colors duration-300 whitespace-nowrap">
              {ex.name}
            </span>
          )}
        </div>
      ))}
    </Marquee>
  </section>
);
